import { ContactData } from "../../../../components/ManagementsUpdate/ManagementsUpdatePowers/ManagementsUpdateNewPowers/ManagementsUpdateNewPowers";
import { NewPowers } from "../../../../core/models/managementsUpdate/managementsUpdatePowers/managementsUpdatePowers";
import { formatDate } from "../../../dateUtils/formatDate.util";

const formatUpdatePowersRequestBody = (
  checkBoxRadioValue: string,
  appliedDay: Date | undefined,
  newPowers: NewPowers,
  notes: string,
  contactData: ContactData
): string => {
  const changedPowers = Object.entries(newPowers).map(
    ([key, value]) => ` ${key.toUpperCase()}:${value}kW`
  );
  const appliedDayFormatted =
    checkBoxRadioValue === "asap"
      ? "Cuanto antes"
      : formatDate(appliedDay as Date);

  return `Potencias solicitadas: ${changedPowers}; Fecha de aplicación: ${appliedDayFormatted}; Persona de contacto: ${
    contactData.contactName
  }; Número de teléfono: ${contactData.phone};  ${
    notes.length ? `Notas: ${notes};` : ""
  }`;
};

export { formatUpdatePowersRequestBody };
